import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-copy-text',
  templateUrl: 'copy-text.component.html',
  styleUrls: ['copy-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyTextComponent {
  @Input()
  public content: any;

  @Input()
  public animationClass = 'bg-secondary';

  @Input()
  public size: 1 | 2 | 3 = 3;

  @ViewChild('iconRef')
  private iconRef: ElementRef;

  constructor(
    private renderer: Renderer2,
  ) {}

  public onCopied(): void {
    if (!this.iconRef.nativeElement) {
      return;
    }

    this.renderer.addClass(this.iconRef.nativeElement, this.animationClass);
    setTimeout(() => this.renderer.removeClass(this.iconRef.nativeElement, this.animationClass), 400);
  }
}
